module.exports = __webpack_public_path__ + "img/fizetos-javitas.5a876f4d.png";